import React, { useContext } from "react";
import { PRODUCTS } from "../../products";
import {ShopContext} from '../../componets/context/shopContext';
import { CartItem } from "./cart-item";
import { useNavigate } from 'react-router-dom'
import { findProductById } from "../../componets/context/shopContext";

export const Cart = () => {

    const { cartItems, getTotalAmount } = useContext(ShopContext);
    const totalAmount = getTotalAmount();
    const navigate = useNavigate();

    return (
        <div className="cart">
            <div className="heading">
                <h1>Shopping Cart</h1>
            </div>
            <div className="cartItems">
            <h3>Please review your order:</h3>
            {Object.keys(cartItems).map((productId) => {
                    const product = findProductById(Number(productId), PRODUCTS);
                    if (product && cartItems[product.id] !== 0) {
                        return <CartItem key={product.id} data={product} />;
                    }
                    return null;
                })}
            </div>
            {totalAmount > 0 ? (
            <div className='checkout'>
                    <p>Subtotal: ₹ {totalAmount} </p>
                    <button onClick={() => navigate('/')}> Continue Shopping </button>
                    <button onClick={() => navigate('/checkout')}> Checkout </button>
            </div>
            ) : (
                    <h1> Your cart is empty !! </h1>
            )}
        </div>
    )
}

export default Cart;